import React, { Component } from 'react';
import { QueryCSContext } from '../contexts/QueryCSContext';
import './CodeSystemBody.css';
import CodeSystemItem from './CodeSystemItem';
import CodeSystemPage from './CodeSystemPage';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import CodeSystemDialog from './CodeSystemDialog';


class CodeSystemBody extends Component {
	state = {
		open: false,
		csResource: {},
	};

	static contextType = QueryCSContext;

	handleClickOpen = async (e) => {
		const { getResource } = this.context;
		await getResource(e);

		const { resource } = this.context;

		this.setState({ open: true });
		this.setState({ csResource: resource });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	formatVersion = (x) => {
		if (x) return `Version : ${x}`;
	};
	render() {
		const { bundle, working } = this.context;


		var nextUrl = false;
		var prevUrl = false;

		if (bundle.entry != null) {
			var next = bundle.link.filter((x) => x.relation === 'next');
			nextUrl = next.length === 0 ? false : true;

			var prev = bundle.link.filter((x) => x.relation === 'previous');
			prevUrl = prev.length === 0 ? false : true;
		}

		const items =
			bundle.entry == null ? this.emptyList() : this.createList(bundle);

		return (
			<React.Fragment>
				<div id="codeSystemBody__id" className="codeSystemBody">
					<CodeSystemPage next={nextUrl} prev={prevUrl} />
					<div id="codeSystemBody__list_id" className="codeSystemBody__list">{items}</div>
					<Backdrop className="codeSystemBody__backdrop" open={working} >
						<CircularProgress color="inherit" />
					</Backdrop>
				</div>

				<Dialog fullWidth={true} maxWidth="lg" open={this.state.open}>
					<div className="codeSystemBody__dialogTitleContainer">
						<div className="codeSystemBody__dialogTitleParts">
							Code System : {this.state.csResource.title}
						</div>
						<div className="codeSystemBody__dialogTitleParts">
							{this.formatVersion(this.state.csResource.version)}
							<div className="pill pill_amber codeSystemBody__dialog-pill">
								{this.state.csResource.status}
							</div>
						</div>
					</div>
					<CodeSystemDialog {...this.state.csResource} />
					<DialogActions>
						<Button
							onClick={this.handleClose}
							variant="contained"
							color="primary"
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		);
	}

	// Alert(props) {
	// 	return <MuiAlert elevation={6} variant="filled" {...props} />;
	// }

	emptyList() {
		return (
			<div className="snackResponse">
				<MuiAlert elevation={6} variant="filled" severity="warning">No data to display</MuiAlert>
			</div>
		);
	}

	// 
	createList(bundle) {
		var items = bundle.entry.map((item) => (
			<CodeSystemItem
				className="codeSystemBody__codeSystemItem"
				item={item.resource}
				key={item.resource.id}
				openFunction={this.handleClickOpen}
			/>
		));

		return items;
	}
}

export default CodeSystemBody;
